import { httpRequest } from "../../http";
import type { Discrepancy } from "@models/Discrepancy.model";

export class CommandGetDiscrepancy {
  async run(id: number): Promise<Discrepancy> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/discrepancies/${id}/`;
    return httpRequest<Discrepancy>(url, { method: "GET" });
  }
}
